import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { useFetchApi } from "../../../../../../hooks/useFetchApi";
import { FinancialAnatomy } from "../components/FinancialAnatomy";
import { BalanceSheetDNA } from "../components/BalanceSheetDNA";
import { SectorIntelligence } from "../components/SectorIntelligence";

const { Title } = Typography;

interface AnnualOutlookProps {
  selectedStock?: any;
  baseCurrency: string;
}

export const AnnualOutlook: React.FC<AnnualOutlookProps> = ({
  selectedStock,
  baseCurrency,
}) => {
  const {
    response: metricsAndEquations,
    loading: metricsAndEquationsLoading,
    execute: getMetricsAndEquations,
  } = useFetchApi("/api/metrics-and-equations", {}, "GET");

  const [metricsData, setMetricsData] = useState<any>(null);

  useEffect(() => {
    getMetricsAndEquations();
  }, []);

  useEffect(() => {
    if (metricsAndEquations && !metricsAndEquationsLoading) {
      setMetricsData(metricsAndEquations);
    }
  }, [metricsAndEquations, metricsAndEquationsLoading]);

  return (
    <div>
      <Title level={5}>Annual Outlook</Title>
      <div className="flex flex-col gap-6">
        <FinancialAnatomy
          baseCurrency={baseCurrency}
          selectedStock={selectedStock}
          metricsData={metricsData}
        />
        <BalanceSheetDNA
          baseCurrency={baseCurrency}
          selectedStock={selectedStock}
          metricsData={metricsData}
        />
        <SectorIntelligence
          baseCurrency={baseCurrency}
          selectedStock={selectedStock}
          metricsData={metricsData}
        />
      </div>
    </div>
  );
};
